/* LayoutMgr.js */

"use strict";
const _ = require("lodash");
const EventEmitter = require("events").EventEmitter;
class LayoutMgr extends EventEmitter {
    constructor() {
        super();
    }
    get namespaceGlobs() {
        return this.getNamespaceGlobs();
    }
    getNamespaceGlobs() {
        return this._namespaceGlobs;
    }
    set namespaceGlobs(ngs) {
        this.setNamespaceGlobs(ngs);
    }
    setNamespaceGlobs() {
        let nsArray = [];
        let silent = false;
        let args = [...arguments];
        //if someone passed in a silent boolean
        if (_.isBoolean(arguments[arguments.length - 1])) {
            args.splice(-1, 1);
            silent = arguments[arguments.length - 1];
        }
        args.forEach((arg) => {
            if (_.isString(arg)) {
                nsArray.push(arg);
            } else if (_.isArray(arg)) {
                nsArray = [...arg, ...nsArray];
            }
        });
        let old = this._namespaceGlobs;
        this._namespaceGlobs = nsArray;
        if (!silent) {
            this.emit("NamespaceGlobsChanged", this._namespaceGlobs, old);
        }
        return this;
    }
    getAllItems() {
        return this._di.getAllRegisteredByGlob(this._namespaceGlobs);
    }
    getItem(fqn) {
        return this._di.getRegistered(fqn);
    }
    createItemFromClass(klass, opts) {
        return this._di.create(klass, opts);
    }
    createItem(fqn, opts) {
        return this._di.createInstance(fqn, opts);
    }
    createScopedItem(fqn, opts) {
        let di = this._di.createDependencyInjector();
        let item = di.createInstance(fqn, opts);
        let instanceName = _.get(opts, "instanceName", "instance." + fqn);
        di._registry.register(instanceName, item);
        return {
            scopedDependencyInjector: di,
            item: item,
            itemRegisteredName: instanceName,
        };
    }
    shutdown() {
        let shutProm = this._di.shutdown();
        shutProm.then(() => {
            this._di = undefined;
        });
        return shutProm;
    }
}
module.exports = LayoutMgr;
